function degToRad(angle) {
    return (angle / 180) * Math.PI;
}
function getCenter(shape) {
    const angleRad = degToRad(shape.rotation || 0);
    return {
        x: shape.x +
            (shape.width / 2) * Math.cos(angleRad) +
            (shape.height / 2) * Math.sin(-angleRad),
        y: shape.y +
            (shape.height / 2) * Math.cos(angleRad) +
            (shape.width / 2) * Math.sin(angleRad),
    };
}
function rotateAroundPoint(shape, deltaDeg, point) {
    const angleRad = degToRad(deltaDeg);
    const x = Math.round(point.x +
        (shape.x - point.x) * Math.cos(angleRad) -
        (shape.y - point.y) * Math.sin(angleRad));
    const y = Math.round(point.y +
        (shape.x - point.x) * Math.sin(angleRad) +
        (shape.y - point.y) * Math.cos(angleRad));
    return Object.assign(Object.assign({}, shape), { rotation: Math.round(shape.rotation + deltaDeg), x,
        y, scaleX: 1, scaleY: 1 });
}
export function rotateAroundCenter(shape, deltaDeg) {
    const center = getCenter(shape);
    return rotateAroundPoint(shape, deltaDeg, center);
}
